import { CODE_TYPES } from './constants';

/**
 * Parse and read category id for given string
 * @param  {String} id
 * @return {String}
 */
export function getCategoryId(id: any) {
    return id.substring(0, id.indexOf('.'));
  }
/**
 * Parse and read subject id for given string
 * @param  {String} id
 * @return {String}
 */
export function getSubjectId(id: any) {
    return id.substring(0, id.indexOf('-'));
  }

  /**
   * Parse and read course id for given string
   * @param  {String} id
   * @return {String}
   */
export function getCourseId(id: any) {
    const ids = id.split('-');
    return `${ids[0]  }-${  ids[1]}`;
  }

  /**
   * Parse and read domain id for given string
   * @param  {String} id
   * @return {String}
   */
export function getDomainId(id: any) {
    const ids = id.split('-');
    return `${ids[0]}-${ids[1]}-${ids[2]}`;
  }

/**
 * Parse and read framework id for given string
 * @param  {String} id
 * @return {String}
 */
export function getFWK(id: any) {
  return id.substring(0, id.indexOf('.'));
}


